export const orangeTheme = {
    background: "#fffaf5",
    headerBg: "#ffd8b5",
    headerText: "#2c2c2c",
    text: "#2c2c2c",
    bubbleUser: "#f3f3f3",
    bubbleAgent: "#ffe0c2",
    bubbleSystem: "#ffd1a1",
    inputBg: "#fff1e4",
    primary: "#ff3d03",
    primaryHover: "#d13300",
    buttonText: "#ffffff",
};

export const darkTheme = {
    background: "#121212",
    headerBg: "#1e1e1e",
    headerText: "#f5f5f5",
    text: "#e0e0e0",
    bubbleSystem: "#ff7043",
    bubbleAgent: "#ff5722",
    bubbleUser: "#2c2c2c",
    inputBg: "#1a1a1a",
    primary: "#ff3d03",
    primaryHover: "#d13300",
    buttonText: "#ffffff",
};

export const blueTheme = {
    background: "#f8fbff",
    headerBg: "#d7e3fc",
    headerText: "#0f172a",
    text: "#1e293b",
    bubbleUser: "#f2f5f9",
    bubbleAgent: "#b0c7f3",
    bubbleSystem: "#e6eefc",
    inputBg: "#dee9fb",
    primary: "#3498db",
    primaryHover: "#2c81b8",
    buttonText: "#ffffff",
};

export const relaxedNightTheme = {
    background: "#0f1820",
    headerBg: "#1c2a36",
    headerText: "#d0e2ff",
    text: "#d6e6ff",
    bubbleSystem: "#2e5a88",
    bubbleAgent: "#1f4b6f",
    bubbleUser: "#27394b",
    inputBg: "#192835",
    primary: "#2e86de",
    primaryHover: "#266eb6",
    buttonText: "#ffffff",
};

export const corporateBlueTheme = {
    background: "#eef3f7",
    headerBg: "#1b2d45",
    headerText: "#ffffff",
    text: "#111111",
    bubbleSystem: "#3a82c4",
    bubbleAgent: "#5dade2",
    bubbleUser: "#e8edf1",
    inputBg: "#f2f6fa",
    primary: "#1b2d45",
    primaryHover: "#2a4164",
    buttonText: "#ffffff",
};

export const forestTheme = {
    background: "#f3f8f5",
    headerBg: "#6da77f",
    headerText: "#1e3525",
    text: "#2b4033",
    bubbleSystem: "#89c27c",
    bubbleAgent: "#6fa387",
    bubbleUser: "#e7f2ec",
    inputBg: "#d3e6da",
    primary: "#7cb08a",
    primaryHover: "#5a8c6a",
    buttonText: "#ffffff",
};

export const smoothBlack = {
    background: "#f5f5f5",
    headerBg: "#ffffff",
    headerText: "#111111",
    text: "#1a1a1a",
    bubbleSystem: "#e0e0e0",
    bubbleAgent: "#cfcfcf",
    bubbleUser: "#bfbfbf",
    inputBg: "#f0f0f0",
    primary: "#000000",
    primaryHover: "#333333",
    buttonText: "#ffffff",
    toastText: "#555555",
};
